<template>
  <h1>Call To Action</h1>
</template>

<script setup lang="ts"></script>

<style lang="postcss" scoped></style>
